import { useAsyncData } from '#imports'
import { type MaybeRef, unref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useProductListPage(id: MaybeRef<string>) {
  const $httpFetch = useHttpFetch()
  const idValue = unref(id)

  return useAsyncData(
    `product-list-page-${idValue}`,
    () =>
      $httpFetch('/bm/landing_page', {
        query: { id: idValue },
      }),
    {
      transform: (data) => {
        if (!data) {
          return null
        }

        const marketingContent = {
          alt: data.marketing_content?.list?.alt,
          url: data.marketing_content?.list?.link?.url,
          label: data.marketing_content?.list?.link?.text,
          srcLarge: data.marketing_content?.list?.urls?.large,
          srcSmall: data.marketing_content?.card?.urls?.small,
        }

        return {
          title: data.displayed_title_plural,
          displayedTitle: data.displayed_title,
          tagline: data.tagline,
          seoText: data.text_seo,
          marketingContent,
          seoTitle: data.title_seo,
          seoDescription: data.description_seo,
          links: data.links,
          breadcrumb: data.breadcrumb,
          popularRelatedLinks: data.popular_related_links,
          landingType: data.landing_type,
          tags: data.tags,
          slug: data.slug,
        }
      },
    },
  )
}
